/* eslint-disable react/no-children-prop */
import React, { Fragment } from 'react';
import {
   Card, CardBody, Col, Badge, Table, Button
} from 'reactstrap';
import { connect } from 'react-redux';
import moment from 'moment';

import { Tooltip } from '@material-ui/core';
// import Button from '@material-ui/core/Button';

import { Field, reduxForm, getFormValues, change } from 'redux-form';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import IconButton from '@material-ui/core/IconButton';
import DownloadIcon from 'mdi-react/CloudDownloadIcon';
import{
	subscriptionPlans,
	_capitalizeText,
	_formatNumber,
	_slugifyText
} from '../../../shared/helpers/utils';
import{
	_axiosCall
} from '../../../shared/helpers/apicalls';
const required = value => value ? undefined : 'Required'
const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined
const maxLength15 = maxLength(15)
const number = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined
const minValue = min => value =>
  value && value < min ? `Must be at least ${min}` : undefined
const minValue18 = minValue(18)
const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
  'Invalid email address' : undefined
const apiUrl = process.env.API_ROOT;


const Exports = ( props ) => {
	const { user, exports, getDownload, total } = props;
	//console.log(user);
	const { subscriptionPlan } = user;
	const currentPlan = subscriptionPlans.filter(plan => plan.id === subscriptionPlan)[0];
	const viewReceipt = (paymentId) => {
	  const req = {
		url: apiUrl + '/buyerslist/stripe/receipt-url',
		method: 'post',
		query: {
		  payment_id: paymentId
		}
	  };
	
	  _axiosCall(req)
		.then(res => {
		  if (res && res.receipt_url) {
			window.open(res.receipt_url, '_blank');
		  } else {
			//alert('Receipt not available.');
		  }
		})
		.catch(() => {
		 // alert('Error retrieving receipt.');
		});
	};

	return(	  
	  <Col md={12} lg={12}>
	    <Card>
	      <CardBody>
	        <div className="card__title">
	          <h5 className="bold-text">{'Download History'}{total > 0 ? ` (${total})` : null}</h5>
	          <h5 className="subhead"></h5>
	        </div>		     
	     	<Table striped responsive>
          <thead>
            <tr>
              <th>Status</th>
              <th style={{minWidth:150}}>Export Date</th> 
              <th>Name</th>  
			  <th>Data Type</th>
              <th>Credits</th>           
              
              <th>Records</th>
                          
              <th style={{minWidth:150}}></th>


            </tr>
          </thead>
          <tbody>
          {exports && exports.map(exp => {
	          let dataType = exp.core_name.replace('we3-', '').replace(/-[0-9]/, '');
	          let download_name = (exp.export_name ? _slugifyText(exp.export_name) : 'mp-data-export-'+ dataType)  + '-' + moment(exp.created_timestamp).format('MM-DD-YYYY-h:mm') + '.csv'
	          return (
		          <tr>
		          	  <td>		 
					  	  	<Badge color="active">Ready</Badge>
					  </td>
		              <td>{moment(exp.created_timestamp).format('M/D/YYYY hh:mm A')}</td>
		              <td>{exp.export_name ? exp.export_name : '--'}
		              	{exp.is_batch_skiptrace &&

			              	<Tooltip title={`Owner Contact Info Export`}>
					  			<IconButton size={`small`} style={{background:"transparent"}}>
					  				<span className="unit-type_badge" style={{background:'#B070CC'}}>Owner Contact Info</span>
					  			</IconButton>
					  		</Tooltip>


		              	}
		              	{exp.is_owner_list && !exp.is_batch_skiptrace &&

			              	<Tooltip title={`Owner List Export`}>
					  			<IconButton size={`small`} style={{background:"transparent"}}>
					  				<span className="unit-type_badge" style={{background:'#B070CC'}}>Owner List</span>
					  			</IconButton>
					  		</Tooltip>


		              	}
						  {exp.is_broker_list &&
								
								<Tooltip title={`Broker List Export`}>
									<IconButton size={`small`} style={{background:"transparent"}}>
										<span className="unit-type_badge" style={{background:'#B070CC'}}>Broker List</span>
									</IconButton>
								</Tooltip>
							
								
							}
		              	{exp.request_owner_email &&
			              	
			              	<Tooltip title={`Owner Email Requested`}>
					  			<IconButton size={`small`} style={{background:"transparent"}}>
					  				<span className="unit-type_badge" style={{background:"#28C2FF"}}>Email Requested</span>
					  			</IconButton>
					  		</Tooltip>
			              	
		              	}
		              </td>	
					  <td>{exp.is_broker_list ? "Brokers" : exp.is_owner_list ? "Owners" : _capitalizeText(dataType)}</td>
					  
		              <td>{exp.is_batch_skiptrace ? _formatNumber(exp.credits || 0) + ' Premium Credits' : exp.credits ? _formatNumber(exp.credits) + ' Premium Credits' : '--'}

					  {exp.payment_id && exp.payment_amount > 0 ? (
						<div style={{ fontSize: '12px' }}>
						  (${Number(exp.payment_amount).toFixed(2)}{' -  '}
						  <span
							style={{cursor: 'pointer' }}
							className="link-text"
							onClick={() => viewReceipt(exp.payment_id)}
						  >
							View Receipt
						  </span>)
						</div>
					  ): exp.credits ? null : !exp.is_batch_skiptrace ? <div>(Included in plan)</div> : null}
					  </td>	              
		              
		              <td>{_formatNumber(exp.rows)}</td>	
			          	              		              		                
			          <td>			          	
						<Button 
							onClick={(e) => {e.stopPropagation();getDownload(exp._id, download_name)}}
							className="modal_ok" type="button" color={'primary'}>
				        	<DownloadIcon style={{marginTop:-3}} /> Download
					    </Button>
			          </td>
		            </tr>
	          )
	          
          })}           
          </tbody>
        </Table>        
	      </CardBody>
	    </Card>
	  </Col>
	)
};


export default Exports;
